/* OS Listicle - Confident Body Slider - Clean Native Carousel */
(() => {
  const ROOT_SELECTOR = '.oslcbs';
  const SLIDER_SELECTOR = '[data-oslcbs-slider]';
  const CARD_SELECTOR = '[data-oslcbs-video-card]';

  function getSliderState(slider) {
    if (!slider.__oslcbsState) {
      slider.__oslcbsState = {
        index: 0,
        autoplayId: null,
      };
    }

    return slider.__oslcbsState;
  }

  function getSlides(slider) {
    return Array.from(slider.querySelectorAll('.oslcbs__slide'));
  }

  function getTrack(slider) {
    return slider.querySelector('.oslcbs__wrapper');
  }

  function getVisibleSlides(slider) {
    const width = window.innerWidth;

    if (width >= 1200) {
      return parseInt(slider.dataset.largeDesktopSlides || '5', 10);
    }

    if (width >= 1024) {
      return parseInt(slider.dataset.desktopSlides || '3', 10);
    }

    if (width >= 768) {
      return parseInt(slider.dataset.tabletSlides || '2', 10);
    }

    const mobileValue = parseInt(slider.dataset.mobileSlides || '12', 10);
    return mobileValue >= 10 ? mobileValue / 10 : mobileValue;
  }

  function getMaxIndex(slider) {
    const slides = getSlides(slider);
    const visibleSlides = getVisibleSlides(slider);

    return Math.max(0, Math.ceil(slides.length - visibleSlides));
  }

  function clampIndex(slider, index) {
    const maxIndex = getMaxIndex(slider);

    if (index < 0) return maxIndex;
    if (index > maxIndex) return 0;

    return index;
  }

  function updateDots(slider) {
    const dots = Array.from(slider.querySelectorAll('.oslcbs__dot'));
    const state = getSliderState(slider);

    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === state.index);
    });
  }

  function goToSlide(slider, index) {
    const track = getTrack(slider);
    const slides = getSlides(slider);

    if (!slider || !track || !slides.length) return;

    const state = getSliderState(slider);
    const nextIndex = clampIndex(slider, index);
    const targetSlide = slides[nextIndex];

    if (!targetSlide) return;

    state.index = nextIndex;

    const offsetLeft = targetSlide.offsetLeft;

    track.style.transform = `translate3d(-${offsetLeft}px, 0, 0)`;

    updateDots(slider);
  }

  function buildDots(slider) {
    const pagination = slider.querySelector('[data-oslcbs-pagination]');
    const slides = getSlides(slider);

    if (!pagination || !slides.length) return;

    pagination.innerHTML = '';

    const maxIndex = getMaxIndex(slider);

    for (let index = 0; index <= maxIndex; index += 1) {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'oslcbs__dot';
      dot.setAttribute('aria-label', `Go to video ${index + 1}`);

      dot.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, index);
      });

      pagination.appendChild(dot);
    }

    updateDots(slider);
  }

  function rebuildDots(slider) {
    buildDots(slider);
    goToSlide(slider, getSliderState(slider).index);
  }

  function startAutoplay(slider) {
    if (!slider || slider.dataset.autoplay !== '1') return;

    const state = getSliderState(slider);
    const delay = parseInt(slider.dataset.autoplayDelay || '4000', 10);
    const autoplayDelay = Number.isFinite(delay) ? delay : 4000;

    stopAutoplay(slider);

    state.autoplayId = window.setInterval(() => {
      goToSlide(slider, getSliderState(slider).index + 1);
    }, autoplayDelay);
  }

  function stopAutoplay(slider) {
    if (!slider) return;

    const state = getSliderState(slider);

    if (state.autoplayId) {
      window.clearInterval(state.autoplayId);
      state.autoplayId = null;
    }
  }

  function stopVideo(card) {
    if (!card) return;

    const video = card.querySelector('.oslcbs__video');
    const overlay = card.querySelector('.oslcbs__video-overlay');
    const playButton = card.querySelector('.oslcbs__play-button');

    if (!video || !overlay || !playButton) return;

    video.pause();
    video.currentTime = 0;

    card.dataset.isPlaying = 'false';
    overlay.classList.remove('is-hidden');
    playButton.classList.remove('is-hidden');
    video.classList.remove('is-playing');
  }

  function stopAllVideos(root) {
    if (!root) return;

    root.querySelectorAll(`${CARD_SELECTOR}[data-is-playing="true"]`).forEach(stopVideo);
  }

  function loadVideo(card, forceAutoPreload = false) {
    if (!card) return;

    const video = card.querySelector('.oslcbs__video');
    const videoSrc = card.dataset.videoSrc;

    if (!video || !videoSrc || card.dataset.videoLoaded === 'true') return;

    video.src = videoSrc;
    video.preload = forceAutoPreload ? 'auto' : 'metadata';
    video.load();

    card.dataset.videoLoaded = 'true';
  }

  async function playVideo(root, card) {
    if (!root || !card) return;

    const slider = card.closest(SLIDER_SELECTOR);
    const video = card.querySelector('.oslcbs__video');
    const overlay = card.querySelector('.oslcbs__video-overlay');
    const playButton = card.querySelector('.oslcbs__play-button');

    if (!video || !overlay || !playButton) return;

    stopAllVideos(root);
    stopAutoplay(slider);

    loadVideo(card, true);
    video.currentTime = 0;

    try {
      await video.play();

      card.dataset.isPlaying = 'true';
      overlay.classList.add('is-hidden');
      playButton.classList.add('is-hidden');
      video.classList.add('is-playing');
    } catch (error) {
      stopVideo(card);
      startAutoplay(slider);
    }
  }

  function initCards(root) {
    if (!root) return;

    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (!card.dataset.initialized) {
        card.dataset.initialized = 'true';
        card.dataset.isPlaying = 'false';
      }

      if (card.dataset.hasCustomPoster === 'false') {
        loadVideo(card, false);
      }
    });
  }

  function bindVideoClicks(root) {
    if (!root || root.__oslcbsVideoClicksBound) return;

    root.__oslcbsVideoClicksBound = true;

    root.addEventListener(
      'click',
      (event) => {
        const playButton = event.target.closest('.oslcbs__play-button');
        const card = event.target.closest(CARD_SELECTOR);

        if (playButton && card && root.contains(card)) {
          event.preventDefault();
          event.stopPropagation();

          playVideo(root, card);
          return;
        }

        if (card && card.dataset.isPlaying === 'true') {
          const slider = card.closest(SLIDER_SELECTOR);

          event.preventDefault();
          event.stopPropagation();

          stopVideo(card);
          startAutoplay(slider);
        }
      },
      true
    );

    root.addEventListener(
      'ended',
      (event) => {
        if (!event.target.classList.contains('oslcbs__video')) return;

        const card = event.target.closest(CARD_SELECTOR);
        const slider = card ? card.closest(SLIDER_SELECTOR) : null;

        stopVideo(card);
        startAutoplay(slider);
      },
      true
    );
  }

  function initSlider(root, slider) {
    if (!root || !slider || slider.__oslcbsBound) return;

    slider.__oslcbsBound = true;

    const track = getTrack(slider);
    const slides = getSlides(slider);
    const prevBtn = slider.querySelector('[data-oslcbs-prev]');
    const nextBtn = slider.querySelector('[data-oslcbs-next]');

    if (!track || !slides.length) return;

    track.style.transform = 'translate3d(0, 0, 0)';

    buildDots(slider);
    goToSlide(slider, 0);

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, getSliderState(slider).index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, getSliderState(slider).index + 1);
      });
    }

    window.addEventListener('resize', () => {
      rebuildDots(slider);
    });

    startAutoplay(slider);
  }

  function initSection(root) {
    if (!root) return;

    bindVideoClicks(root);
    initCards(root);

    root.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => {
      initSlider(root, slider);
    });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        stopAllVideos(root);

        root.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => {
          stopAutoplay(slider);
        });
      });
    }
  });

  if (document.readyState !== 'loading') {
    init();
  }
})();